export const siteInfo = {
  brandKo: "한국고무공업주식회사",
  brandShort: "한국고무공업",
  brandEn: "HANKUK RUBBER TECH. CO.,LTD.",
  tel: "031-434-0341",
  telLink: "tel:031-434-0341",
  email: "hkrubbert@naver.com",
  emailLink: "mailto:hkrubbert@naver.com",
  fax: "031-434-0340",
  address: "경기도 시흥시 옥구천서로 237번길 36",
  established: 1975,
  experienceYears: 50,
  ceo: "김철수",
  employees: 85,
  factoryArea: "6,600㎡",
  annualRevenue: "연 120억",
  mainCustomers: "현대자동차, 기아, 현대중공업, 두산중공업, LS ELECTRIC, 효성중공업, 한화에어로스페이스, 한국전력공사",
};

export interface NavSubLink {
  label: string;
  to: string;
}

export interface NavLinkItem {
  label: string;
  to: string;
  sub?: NavSubLink[];
}

export const navLinks: NavLinkItem[] = [
  { label: "HOME", to: "/" },
  {
    label: "회사소개",
    to: "/about/overview",
    sub: [
      { label: "CEO 인사말", to: "/about/ceo" },
      { label: "회사개요", to: "/about/overview" },
      { label: "회사연혁", to: "/about/history" },
      { label: "인증현황", to: "/about/certifications" },
      { label: "찾아오는 길", to: "/about/location" },
    ],
  },
  {
    label: "사업소개",
    to: "/business",
  },
  {
    label: "제품소개",
    to: "/products",
  },
  {
    label: "기술자료",
    to: "/technical",
  },
  {
    label: "고객지원",
    to: "/support",
  },
  {
    label: "견적요청",
    to: "/quotation",
  },
  {
    label: "문의하기",
    to: "/contact",
  },
];

export const strengths = [
  {
    no: "01",
    icon: "ri-tools-line",
    title: "맞춤형 고무제품 개발",
    desc: "고객의 요구사항을 분석하여 도면 설계부터 시제품 제작까지 원스톱으로 진행합니다.",
    tag: "Custom Design",
  },
  {
    no: "02",
    icon: "ri-settings-3-line",
    title: "산업용 고무 부품 제조",
    desc: "자동차, 전자, 건설, 중공업 등 다양한 산업 분야의 정밀 고무 부품을 양산합니다.",
    tag: "Industrial",
  },
  {
    no: "03",
    icon: "ri-stack-line",
    title: "압축성형 전문",
    desc: "50년간 축적된 압축성형 기술로 고품질 고무제품을 안정적으로 제조합니다.",
    tag: "Compression",
  },
  {
    no: "04",
    icon: "ri-pencil-ruler-2-line",
    title: "금형 개발 협력",
    desc: "전문 금형 파트너사와의 협업으로 복잡한 형상의 제품도 정확하게 구현합니다.",
    tag: "Tooling",
  },
  {
    no: "05",
    icon: "ri-line-chart-line",
    title: "소량~대량 생산 가능",
    desc: "시제품 1개부터 월 100만개 양산까지, 고객의 수량 요구에 유연하게 대응합니다.",
    tag: "Flexible MOQ",
  },
  {
    no: "06",
    icon: "ri-shield-check-line",
    title: "품질관리 및 기술지원",
    desc: "ISO 기반 품질관리 체계와 전담 엔지니어의 사후 기술지원을 제공합니다.",
    tag: "Quality",
  },
];

export const latestProducts = [
  {
    id: "oring-001",
    name: "O-Ring 시리즈",
    category: "오링/씰",
    application: "자동차 · 산업기계",
    material: "EPDM 70",
    image:
      "https://readdy.ai/api/search-image?query=Close-up%20of%20black%20rubber%20O-rings%20circular%20rings%20arranged%20in%20a%20neat%20row%20on%20clean%20light%20beige%20studio%20background%2C%20perfect%20circular%20torus%20shapes%20with%20matte%20rubber%20texture%2C%20industrial%20sealing%20components%2C%20precision%20engineering%20product%20photography%2C%20soft%20diffused%20lighting%2C%20minimal%20composition%20highlighting%20the%20ring%20form&width=900&height=900&seq=krubber-product-01-v2&orientation=squarish",
  },
  {
    id: "bushing-002",
    name: "부싱 (Custom)",
    category: "부싱/마운트",
    application: "중장비 · 농기계",
    material: "NBR 65",
    image:
      "https://readdy.ai/api/search-image?query=Industrial%20black%20rubber%20cylindrical%20bushing%20parts%20arranged%20on%20clean%20light%20beige%20studio%20background%2C%20precision%20engineering%20components%2C%20editorial%20product%20photography%2C%20soft%20diffused%20lighting%2C%20technical%20industrial%20aesthetic&width=900&height=900&seq=krubber-product-02&orientation=squarish",
  },
  {
    id: "vibration-pad-003",
    name: "진동 패드",
    category: "패드/마운트",
    application: "전자 · 의료기기",
    material: "Silicone 60",
    image:
      "https://readdy.ai/api/search-image?query=Translucent%20silicone%20rubber%20anti-vibration%20pads%20on%20clean%20light%20beige%20studio%20background%2C%20industrial%20component%20photography%2C%20soft%20natural%20lighting%2C%20precision%20engineered%20parts%2C%20minimalist%20technical%20composition&width=900&height=900&seq=krubber-product-03&orientation=squarish",
  },
  {
    id: "diaphragm-004",
    name: "다이아프램",
    category: "다이아프램",
    application: "화학 · 펌프",
    material: "FKM (Viton)",
    image:
      "https://readdy.ai/api/search-image?query=Black%20industrial%20rubber%20diaphragm%20parts%20arranged%20on%20clean%20light%20beige%20studio%20background%2C%20fluorinated%20rubber%20components%20for%20chemical%20industry%2C%20editorial%20product%20photography%2C%20matte%20texture%2C%20technical%20engineering%20shot&width=900&height=900&seq=krubber-product-04&orientation=squarish",
  },
  {
    id: "heat-exchanger-gasket-005",
    name: "열교환기용 가스켓",
    category: "가스켓",
    application: "화학 · 발전 · 플랜트",
    material: "EPDM / PTFE",
    image:
      "https://readdy.ai/api/search-image?query=Industrial%20rubber%20gasket%20for%20heat%20exchanger%20with%20precise%20cutouts%20and%20bolt%20holes%20on%20clean%20light%20beige%20studio%20background%2C%20flat%20black%20rubber%20sealing%20sheet%2C%20plate%20heat%20exchanger%20component%2C%20precision%20engineering%20product%20photography%2C%20soft%20studio%20lighting%2C%20technical%20industrial%20aesthetic&width=900&height=900&seq=krubber-product-05-v2&orientation=squarish",
  },
  {
    id: "custom-gasket-006",
    name: "맞춤형 가스켓",
    category: "가스켓",
    application: "조선 · 중공업",
    material: "CR / EPDM",
    image:
      "https://readdy.ai/api/search-image?query=Custom%20industrial%20rubber%20gaskets%20arranged%20on%20clean%20light%20beige%20studio%20background%2C%20various%20shapes%20and%20sizes%2C%20black%20rubber%20sealing%20components%2C%20editorial%20engineering%20product%20photography%2C%20soft%20diffused%20studio%20lighting&width=900&height=900&seq=krubber-product-06&orientation=squarish",
  },
];